/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypePresentationIcon20Solid = forwardRef('FileTypePresentationIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 6.245A3.755 3.755 0 1 0 13.755 10H10.25a.25.25 0 0 1-.25-.25V6.245Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.988 2.586A2 2 0 0 0 11.573 2H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7.427a2 2 0 0 0-.586-1.415l-3.426-3.426ZM4.995 10a5.005 5.005 0 1 1 10.01 0 5.005 5.005 0 0 1-10.01 0Z" })));
});
